import { DateTime } from 'luxon';

const stringFormat = 'yyyy-MM-dd';

export function getDateFromDTODate(date?: string): Date | undefined {
  if (date) {
    return DateTime.fromFormat(date, stringFormat).toJSDate();
  }
}
